<template>
	<c-dialog ref="dialog" width="600" mask-close>
		<div class="m-express-body">
			<div class="m-express-item">
				<label class="m-label"><span class="m-required">*</span> 退货快递公司</label>
				<c-input v-model="returnExpressCompany" placeholder="请输入退货快递公司" maxlength="50"></c-input>
			</div>
			<div class="m-express-item">
				<label class="m-label"><span class="m-required">*</span> 退货快递单号</label>
				<c-input v-model="returnExpressNo" placeholder="请输入/扫描退货快递单号" maxlength="50"></c-input>
			</div>
		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleReturnExpress',

		data() {
			return {
				afterSaleId: '',
				returnExpressCompany: '',
				returnExpressNo: ''
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.afterSaleId = data.afterSaleId;
				this.returnExpressCompany = '';
				this.returnExpressNo = '';
				this.$refs.dialog.open({title: '登记退货物流'});
			},

			/*********提交**********/
			submitHandle() {
				if (!this.returnExpressCompany.trim()) {
					this.$message({message: '请输入退货快递公司', type: 'warn'});
					return;
				}
				if (!this.returnExpressNo.trim()) {
					this.$message({message: '请输入退货快递单号', type: 'warn'});
					return;
				}
				this.request({
					url: '/aftersale/returnExpress',
					data: {
						id: this.afterSaleId,
						return_express_company: this.returnExpressCompany.trim(),
						return_express_no: this.returnExpressNo.trim()
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '登记成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-express-body {
		padding: 16px 24px;
	}

	.m-express-item {
		margin-bottom: 16px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}
	}
</style>
